import React, { useState, FC } from "react";
import Icon from "components/icon";
import { Navbar, NavbarBrand, Collapse, NavbarToggler, Nav } from "reactstrap";
import "./header.scss";

const Header: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar className="navbar-header" dark expand="md">
      <div className="container">
        <NavbarBrand>
          <Icon name="sasr" />
        </NavbarBrand>
        <NavbarToggler className="d-none" onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
          </Nav>
        </Collapse>
      </div>
    </Navbar>
  );
};

export default Header;
